import {Tabs} from '@superweb/ui'
import React from 'react'

import {type BlockWithCommonSubblocksType} from '../../../../../../api'
import {Paper} from '../../../../../../components/ui'
import {CommonBlock} from '../CommonBlock'
import {Subtitle, Title} from '../ui'
import styleClasses from './classes.module.css'

type Props = {
  block: BlockWithCommonSubblocksType
}

export function BlockWithCommonSubblocks({block}: Props) {
  const {title, subtitle, blocks} = block

  const tabItems =
    blocks.length > 0
      ? blocks.map(subblock => ({
          label: subblock.title,
          content: <CommonBlock block={subblock} isSubblock />,
        }))
      : []

  return (
    <Paper>
      <div className={styleClasses.wrapper}>
        <Title title={title} />
        {subtitle && <Subtitle subtitle={subtitle} />}
        {tabItems.length > 0 && <Tabs items={tabItems} />}
      </div>
    </Paper>
  )
}
